import React, { useState } from "react";
import { Badge, Button, Collapse } from "react-bootstrap";
import { ChevronDown, ChevronUp, ArrowCounterclockwise, Wallet } from "react-bootstrap-icons";
import { formatJalali } from "../../utils/date";

const money = (value) => Number(value || 0).toLocaleString("fa-IR");

const PurchaseAccountItem = ({ purchase, role }) => {
  const [expanded, setExpanded] = useState(true);
  const refunds = purchase.refunds || [];
  const status = purchase.refundStatus || (Number(purchase.refundedAmount) > 0 ? "partial" : "none");
  const statusConfig = {
    none: { label: "بدون برگشت", bg: "secondary" },
    partial: { label: "برگشت جزئی", bg: "warning" },
    full: { label: "برگشت کامل", bg: "success" },
  }[status] || { label: "بدون برگشت", bg: "secondary" };

  const customerName = `${purchase.user?.name || ""} ${purchase.user?.family || ""}`.trim();

  return (
    <div className="border rounded-3 bg-white mb-2 overflow-hidden">
      <div className="p-3">
        <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
          <div className="fw-semibold">{purchase.store?.name || "خرید فروشگاهی"}</div>
          <Badge bg={statusConfig.bg} text={status === "partial" ? "dark" : undefined}>
            {statusConfig.label}
          </Badge>
          <span className="text-muted small ms-auto" style={{ direction: "ltr" }}>
            {formatJalali(purchase.createdAt)}
          </span>
        </div>

        <div className="d-flex flex-wrap align-items-center gap-3 gap-lg-4">
          <div className="flex-grow-1" style={{ minWidth: 115 }}>
            <div className="text-muted small">مبلغ خرید</div>
            <div className="fw-semibold">{money(purchase.amount)} <small className="text-muted fw-normal">تومان</small></div>
          </div>
          <div className="flex-grow-1" style={{ minWidth: 115 }}>
            <div className="text-muted small">مبلغ نهایی</div>
            <div className="fw-bold text-success">{money(purchase.netAmount ?? (Number(purchase.amount) - Number(purchase.refundedAmount || 0)))} <small className="text-muted fw-normal">تومان</small></div>
          </div>
          {role !== "USER" && (
            <div className="flex-grow-1" style={{ minWidth: 130 }}>
              <div className="text-muted small">خریدار</div>
              <div className="small fw-medium">{customerName || "-"}</div>
              {role === "ADMIN" && purchase.user?.mobile && (
                <div className="text-muted small" dir="ltr">{purchase.user.mobile}</div>
              )}
            </div>
          )}
          <div className="text-muted small">
            #{purchase.id} <span className="mx-1">·</span>
            {purchase.source === "wallet" ? "کیف پول" : purchase.source === "credit" ? "اعتبار" : purchase.source || "-"}
          </div>
          {refunds.length > 0 && (
            <Button
              variant="light"
              size="sm"
              className="ms-auto text-muted"
              onClick={() => setExpanded((value) => !value)}
            >
              {expanded ? "بستن جزئیات" : "جزئیات برگشت"}
              {expanded ? <ChevronUp className="ms-1" /> : <ChevronDown className="ms-1" />}
            </Button>
          )}
        </div>

        {purchase.description && (
          <div className="text-muted small mt-2">{purchase.description}</div>
        )}
      </div>

      {refunds.length > 0 && (
        <Collapse in={expanded}>
          <div className="border-top bg-light px-3 py-2">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
              <div className="small fw-semibold text-muted">
                <ArrowCounterclockwise className="me-1" />
                {refunds.length.toLocaleString("fa-IR")} برگشت
              </div>
              <div className="small fw-semibold text-danger">
                مجموع برگشتی: {money(purchase.refundedAmount)} تومان
              </div>
            </div>

            <div className="d-flex flex-column gap-2">
              {refunds.map((refund) => (
                <div key={refund.id} className="d-flex flex-wrap align-items-center gap-2 small">
                  <span className="text-muted" style={{ minWidth: 82 }}>
                    برگشت #{refund.id}
                  </span>
                  <span className="text-muted" style={{ direction: "ltr" }}>
                    {formatJalali(refund.createdAt)}
                  </span>
                  {refund.chargedToUser || refund.chargeTransaction ? (
                    <Badge bg="success" className="fw-normal">
                      <Wallet className="me-1" /> شارژ اعتبار کاربر
                      {refund.chargeTransaction?.id ? ` #${refund.chargeTransaction.id}` : ""}
                    </Badge>
                  ) : (
                    <Badge bg="danger" className="fw-normal">بدون برگشت اعتبار</Badge>
                  )}
                  {refund.description && <span className="text-muted">{refund.description}</span>}
                  <span className="ms-auto text-danger fw-semibold">{money(refund.amount)}- تومان</span>
                </div>
              ))}
            </div>
          </div>
        </Collapse>
      )}
    </div>
  );
};

export default PurchaseAccountItem;
